import type { DayKey, PickupMethodKey } from "@/mocks/branch/settings";

export interface DayOption {
  key: DayKey;
  label: string;
}

export const WEEK_DAYS: DayOption[] = [
  { key: "sat", label: "السبت" },
  { key: "sun", label: "الأحد" },
  { key: "mon", label: "الاثنين" },
  { key: "tue", label: "الثلاثاء" },
  { key: "wed", label: "الأربعاء" },
  { key: "thu", label: "الخميس" },
  { key: "fri", label: "الجمعة" },
];

export interface PickupMethodOption {
  key: PickupMethodKey;
  label: string;
  icon: string;
  description: string;
}

export const PICKUP_METHOD_OPTIONS: PickupMethodOption[] = [
  {
    key: "dine_in",
    label: "تناول محلي",
    icon: "ri-restaurant-line",
    description: "استلام الطلب داخل المطعم",
  },
  {
    key: "takeaway",
    label: "سفري",
    icon: "ri-shopping-bag-line",
    description: "استلام الطلب من الكاونتر",
  },
  {
    key: "car",
    label: "استلام بالسيارة",
    icon: "ri-car-line",
    description: "توصيل الطلب إلى السيارة",
  },
];

/** ساعات ممتدة لما بعد منتصف الليل: وقت الإغلاق أصغر من وقت الفتح */
export function isOvernight(open: string, close: string): boolean {
  if (!open || !close) return false;
  return close < open;
}

/** تحقق من صحة رقم تواصل سعودي (أرضي 011xxxxxxx أو جوال 05xxxxxxxx) */
export function isValidContactPhone(phone: string): boolean {
  const digits = phone.replace(/[\s-]/g, "");
  return /^0\d{8,9}$/.test(digits);
}

